import { act } from "react";


const initialState = {
    count: 0,
    isAuthenticated: false,
    sidebarExpanded: false,
    user:{},
    store:{store_logo:'1722240569logo.png',store_title:'रघुवीर सिंह राजकीय महाविद्यालय, ललितपुर=Raghuveer Singh Government Degree College, Lalitpur '},
    sliders:['https://campus.acetians.in/custom/images/1722342842lalitpurlogo.png'],
    notices:[],
    gallery_images:[],
    courses:[],
    link:[],
    staffs:[],
    dataLoaded:false,
    hasVideoSection: false,
    videos:[]
};

const rootReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'LOGIN':
            return { ...state, isAuthenticated: true };
        case 'EXPAND':
            return { ...state, sidebarExpanded: true };
        case 'COMPRESS':
            return { ...state, sidebarExpanded: false };
        case 'SET_STORE_DATA':
            return {...state,store:action.payload};
        case 'SET_STORE_SLIDERS':
                return {...state,sliders:action.payload};
        case 'SET_NOTICES':
                return {...state,notices:action.payload};
        case 'SET_GALLERY_IMAGES':
                return {...state,gallery_images:action.payload};
        case 'SET_COURSE_DATA':
                return {...state,courses:action.payload};
        case 'SET_LINK':
                return {...state,link:action.payload};
        case 'SET_STAFF':
            return {...state,staffs:action.payload};
        case 'DATA_LOADED':
            return {...state,dataLoaded:true}
        case 'VIDEOS':
            return {...state,videos:action.payload.data,hasVideoSection:action.payload.videosection === 1 }
        default: 
            return state;
    }
};

export default rootReducer;
